import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { marked } from 'marked';

const ChatWidget = () => {
    const [messages, setMessages] = useState([
        { role: 'assistant', content: "Hello. I am Hardik's Portfolio Assistant. How can I help you regarding his work or research?" }
    ]);
    const [input, setInput] = useState('');
    const [loading, setLoading] = useState(false);
    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const handleSend = async (e) => {
        e.preventDefault();
        if (!input.trim()) return;

        const userMsg = { role: 'user', content: input };
        setMessages(prev => [...prev, userMsg]);
        setInput('');
        setLoading(true);

        try {
            // Prepare history (last 5 messages to save context, excluding system)
            const history = messages.slice(-5).map(m => ({ role: m.role, content: m.content }));

            const res = await axios.post('/api/chat', {
                message: userMsg.content,
                history: history
            });

            const aiMsg = { role: 'assistant', content: res.data.reply };
            setMessages(prev => [...prev, aiMsg]);
        } catch (error) {
            console.error("Chat error:", error);
            setMessages(prev => [...prev, { role: 'assistant', content: "I apologize, but I am currently unable to connect to the server." }]);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bento-card" style={{ fontFamily: '"Crimson Text", serif', display: 'flex', flexDirection: 'column', height: '500px' }}>
            <div style={{ borderBottom: '1px solid #ddd', paddingBottom: '10px', marginBottom: '10px' }}>
                <h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 'bold' }}>Portfolio AI Assistant</h3>
            </div>

            <div style={{ flex: 1, overflowY: 'auto', marginBottom: '10px', paddingRight: '5px' }}>
                {messages.map((m, i) => (
                    <div key={i} style={{
                        marginBottom: '10px',
                        textAlign: m.role === 'user' ? 'right' : 'left'
                    }}>
                        <div style={{
                            display: 'inline-block',
                            maxWidth: '85%',
                            padding: '8px 12px',
                            background: m.role === 'user' ? '#f0f0f0' : '#fff',
                            border: m.role === 'user' ? '1px solid #ccc' : 'none',
                            borderRadius: '4px',
                            textAlign: 'left',
                            fontSize: '0.95rem'
                        }}>
                            {m.role === 'assistant' ? (
                                <div dangerouslySetInnerHTML={{ __html: marked.parse(m.content) }} />
                            ) : (
                                m.content
                            )}
                        </div>
                    </div>
                ))}
                {loading && (
                    <div style={{ textAlign: 'left', fontStyle: 'italic', color: '#888', fontSize: '0.8rem' }}>
                        Thinking...
                    </div>
                )}
                <div ref={messagesEndRef} />
            </div>

            <form onSubmit={handleSend} style={{ display: 'flex', borderTop: '1px solid #ddd', paddingTop: '10px' }}>
                <input
                    type="text"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder="Ask about my research..."
                    style={{
                        flex: 1,
                        padding: '8px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        fontFamily: '"Crimson Text", serif',
                        fontSize: '1rem',
                        marginRight: '5px'
                    }}
                />
                <button type="submit" disabled={loading} style={{
                    background: '#111', color: '#fff', border: 'none', padding: '8px 15px', borderRadius: '4px', cursor: 'pointer',
                    fontFamily: '"Inter", sans-serif'
                }}>
                    Send
                </button>
            </form>
        </div>
    );
};

export default ChatWidget;
